<template>
    <el-dialog
        title="详情"
        :visible.sync="show"
        width="900px"
        @close="handleClose">
        <div class="account-detail-pop-wrap" v-loading="isLoading">
            <div class="top-box">
                <div class="account-info-box">
                    <div class="info-txt">{{ accountInfo.account_name }}</div>
                    <div class="info-txt">{{ accountInfo.account }}</div>
                    <div class="info-txt info-txt-name">{{ accountInfo.name }}</div>
                    <div v-if="statusColor[accountInfo.status].showFail" class="info-txt info-txt-fail">失败原因：{{ accountInfo.status_msg || '审核失败' }}</div>
                </div>
                <div class="account-status-box" :style="{color: statusColor[accountInfo.status].color}">
                    {{ statusColor[accountInfo.status].title }}
                </div>
            </div>
            <div class="bottom-box">
                <div class="tip-txt">
                    请依次完成下面所有商户认证
                </div>
                <el-table
                    :data="tableList"
                    style="width: 100%"
                    >
                    <el-table-column
                        v-for="(item,index) in headerList"
                        :key="index"
                        :label="item.label"
                        :width="item.width" >
                        <template slot-scope="scope">
                            <div v-if="item.prop=='my_zhuangTai'" class="table-status-cell">
                                <span class="status-txt" :class="[merchantStatusObj[scope.row.merchant_status].needValidate&&'txt-pointer']" @click="clkMerchantStatus(scope.row)">
                                    {{ merchantStatusObj[scope.row.merchant_status].title }}
                                </span>
                                <span class="fail-reason" v-if="merchantStatusObj[scope.row.merchant_status].showFail">
                                    原因：{{ scope.row.merchant_status_msg || '审核失败' }}
                                </span>
                            </div>
                            <div v-else>
                                {{ scope.row[item.prop] || '--' }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import { accountList_statusColorObj, accountList_merchantStatusObj } from '../data.js'
    import { mapActions } from 'vuex'
    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            id: { // 账户id
                type: [Number, String],
                default: ''
            }
        },
        watch: {
            value(nval){
                if(nval){
                    this.initData()
                }
                this.show = nval
            }
        },  
        data(){
            return {
                show: false,
                isLoading: false, // 加载中
                statusColor: accountList_statusColorObj, // 账户状态相关(银行卡的大状态)
                merchantStatusObj: accountList_merchantStatusObj,// 商户状态相关
                accountStatus: 2, // 当前账户状态
                headerList: [
                    {
                        prop: 'merchant_name',
                        label: '商户名称'
                    },
                    {
                        prop: 'my_zhuangTai',
                        label: '状态',
                    },
                ],
                accountInfo:{ // 账户信息
                    status: 1
                }, 
                tableList: [],// 表格数据
            }
        },
        methods: {
            ...mapActions('withdrawal',['getAccountMerchantDetailAPI']),
            // 初始化数据
            async initData(){
                this.isLoading = true
                let res = await this.getAccountMerchantDetailAPI({
                    id: this.id
                })
                this.accountInfo = res.account_info
                this.tableList = res.payment_merchant_list || []
                // console.log('initData-res:',res)
                this.isLoading = false
            },
            handleClose() {
                this.$emit('input', false)
            },
            // 点击商户状态
            clkMerchantStatus(item){
                // console.log('item:',item)
                let { merchant_status, merchant_log_id } = item
                if(this.merchantStatusObj[merchant_status].needValidate){
                    // this.$emit('input', false)
                    this.$emit('toValidate',{
                        account_id: this.id,
                        merchant_log_id
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">
.account-detail-pop-wrap{
    .top-box{
        padding: 20px;
        border: 1px solid #D7D7D7;
        border-radius: 10px;
        position: relative;
        .account-info-box{
            .info-txt{
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 8px;
                color: #000;
                &:last-child{
                    margin-bottom: 0px;
                }
                &.info-txt-name{
                    color: #606266;
                }
                &.info-txt-fail{
                    font-size: 15px;
                    color: red;
                }
            }
        }
        .account-status-box{
            position: absolute;
            right: 20px;
            top: 20px;
            font-size: 16px;
            line-height: 16px;
        }
    }
    .bottom-box{
        border-top: 1px solid #ccc;
        margin-top: 20px;
        padding-top: 20px;
        .table-status-cell{
            .status-txt{
                &.txt-pointer{
                    color: #0082f4;
                    cursor: pointer;
                }
            }
            .fail-reason{
                margin-left: 10px;
                color: red;
            }
        }
    }
}
</style>